import api from './api'

export default {
  unreadSummary() {
    return api.get('/partner-licensings/:partnerLicensingId/messages/unread-summary')
  },
}
